import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing/app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ClientQueryComponent } from './client-query/client-query.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ManufacturingComponent } from './manufacturing/manufacturing.component';
import { RestaurantorderbookingComponent } from './restaurantorderbooking/restaurantorderbooking.component';
import { RestauranttablecountersaleComponent } from './restauranttablecountersale/restauranttablecountersale.component';
import { RetailmanagementComponent } from './retailmanagement/retailmanagement.component';
import { SchoolmanagementComponent } from './schoolmanagement/schoolmanagement.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    ClientQueryComponent,
    AboutusComponent,
    ManufacturingComponent,
    RestaurantorderbookingComponent,
    RestauranttablecountersaleComponent,
    RetailmanagementComponent,
    SchoolmanagementComponent
  ],
  imports: [
      BrowserModule,
      HttpModule,
      FormsModule,
      AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/app/app.module.ts